import { render, staticRenderFns } from "./AppEpisodeList.vue?vue&type=template&id=ba63d3ca&scoped=true&"
import script from "./AppEpisodeList.vue?vue&type=script&lang=js&"
export * from "./AppEpisodeList.vue?vue&type=script&lang=js&"
import style0 from "./AppEpisodeList.vue?vue&type=style&index=0&id=ba63d3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba63d3ca",
  null
  
)

export default component.exports